import { Breadcrumb, Button, Layout, Menu, theme } from 'antd';

import FindIntro from './Content/FindIntro';
import ShowCoach from './Content/ShowCoach';
import Offer from './Content/Offer';
import Feedback from "./Content/Feedback";
import Question from './Content/Question';
import UseDevice from './Content/UseDevice';
import QuickAccess from './Content/QuickAccess';
import { styled } from 'styled-components';
import { contentStyle } from '../fuctions';
import { Input } from 'antd';
import GroupClassIntro from './Content/GroupClassIntro';
import ShowGroupClassCoach from "./Content/ShowGroupClassCoach";
import SearchInput from "../components/SearchInput";

import { SearchOutlined } from '@ant-design/icons';
const { Header, Content, Footer } = Layout;
const GroupClassContent = () => {
    const user = false;
    return <Content>
        {!user ?
            <>
                {/* <Intro></Intro> */}
            </> :
            <Button>33sss</Button>}
        <GroupClassIntro></GroupClassIntro>
        <SearchInput></SearchInput>
        <ShowGroupClassCoach></ShowGroupClassCoach>
        <QuickAccess></QuickAccess>
    </Content>;
};

export default GroupClassContent;
